import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall, logoutUser } from '../../../API';
import * as Toast from "../../../components/shared/Toast";

export const getallGroupMappingACTION = createAsyncThunk(
    'GroupMapping/getallGroupMapping',
    async (data) => {
        console.log("data in action", data)
        let d = {
            device: data.device !== undefined ? data.device : 1,
            pageNo: data.pageNo !== undefined ? data.pageNo : -1,
            pageSize: data.pageSize !== undefined ? data.pageSize : 0,
            sortBy: data.sortBy !== undefined ? data.sortBy : 0,
            sortOrder: data.sortOrder !== undefined ? data.sortOrder : 0,
            filter: data.filter || {},
            serverID: data.serverID || null
        };
        return apiCall('/admin/groupmapping/getallwithdetail', 'POST', d, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        return {
                            ...response.data,
                        };
                    } else {
                        Toast.error(response.data.message.message);
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject({
                    ...error,
                });
            });

    }
);